import { CopyIcon } from "@radix-ui/react-icons"

import { Button } from "../ui/button"
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog"
import { Input } from "../ui/input"
import { Label } from "../ui/label"
import { toast } from "../ui/use-toast"

function InviteMemberDialog({ link, clubName, isLoading }) {
    

    const handleCopy = () => {
      navigator.clipboard.writeText(link)
        .then(() => {
          toast({
            title: 'Länk kopierad.',
          });
        })
        .catch(() => {
          toast({
            variant: 'destructive',
            title: 'Något gick fel.',
            description: 'Det gick inte att kopiera länken.',
          }); // Show error toast if copying fails
        });
    };

  return (
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Dela inbjudningslänk till {clubName}</DialogTitle>
          <DialogDescription>
            Kopiera länken nedan och skicka den till personen du vill bjuda in. Länken är giltig i 24 timmar.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2">
          <div className="grid flex-1 gap-2">
            <Label htmlFor="link" className="sr-only">
              Link
            </Label>
            <Input
              id="link"
              placeholder="Laddar..."
              value={link}
              disabled={isLoading}
              readOnly
            />
          </div>
          <Button type="submit" onClick={handleCopy} size="sm" className="px-3" disabled={isLoading} >
            <span className="sr-only">Kopiera</span>
            <CopyIcon className="h-4 w-4" />
          </Button>
        </div>
        <DialogFooter className="sm:justify-start">
          <DialogClose asChild>
            <Button type="button" variant="secondary">
              Stäng
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
  );
}

export default InviteMemberDialog;